import React, { useState } from 'react';
import './ActionButtonsBlock.scss';
import { Download, Export, Share, DownloadExcelIcon, ShareIcon, CopyIcon } from "../../styles/icons/svg";
import NotificationModel from './NotificationModel';
import moment from "moment";

const ActionButtonsBlock = ({ serviceDueOnDate }) => {

    const [openNotiModel, setOpenNotiModel] = useState(false);

    const copyToClipboard = () => {
        var textField = document.createElement('textarea');
        textField.innerText = window.location.href;
        document.body.appendChild(textField)
        textField.select()
        document.execCommand('copy');
        textField.remove();
        setOpenNotiModel(false);
    }

    const notificationModelContent = () => {
        // eslint-disable-next-line eqeqeq
        if (openNotiModel == 'DOWNLOAD') {
            return (
                <div className="download-wrap">
                    <div className="icon-wrap">
                        <div className="circle">
                            <span>
                                <Download />
                            </span>
                        </div>
                    </div>
                    <div className="title-wrap">Download</div>
                    <div className="actions-wrap">
                        <div className="action brd-lb" >
                            Compact PDF
                        </div>
                        <div className="action brd-lr" >
                            Expanded PDF
                        </div>
                        <div className="action brd-rb" onClick={() => setOpenNotiModel(false)}>
                            Cancel
                        </div>
                    </div>
                </div>
            )
        }

        // eslint-disable-next-line eqeqeq
        if (openNotiModel == 'EXCEL') {
            return (
                <div className="download-wrap">
                    <div className="icon-wrap">
                        <div className="circle">
                            <span>
                                <DownloadExcelIcon />
                            </span>
                        </div>
                    </div>
                    <div className="title-wrap">Download the Excel File</div>
                    <div className="actions-excel-wrap">
                        <div className="action brdr-lb">
                            Yes
                        </div>
                        <div className="action brd-left brdr-rb" onClick={() => setOpenNotiModel(false)}>
                            No
                        </div>
                    </div>
                </div>
            )
        }

        // eslint-disable-next-line eqeqeq
        if (openNotiModel == 'SHARE') {
            return (
                <div className="share-wrap">
                    <div className="share-icon-wrap">
                        <div className="circle">
                            <span style={{ marginTop: '3px', marginRight: '2px' }}>
                                <ShareIcon />
                            </span>
                        </div>
                        Share Service List
                    </div>
                    <div className="share-copy-wrap">
                        <div className="gray-block">T</div>
                        <div style={{ width: '195px' }}>Service List {moment(serviceDueOnDate).format('DD MMM YYYY')}</div>
                        <div style={{ padding: '12px', marginLeft: '10px', cursor: 'pointer' }} onClick={copyToClipboard}>
                            <CopyIcon />
                        </div>
                    </div>
                </div>
            )
        }
    }

    return (
        <React.Fragment>
            <div className="actions-buttons-wrap">
                <div className="action brd-lb" onClick={() => setOpenNotiModel('DOWNLOAD')}>
                    Download
                    <span className="download-icon">
                        <Download />
                    </span>
                </div>
                <div className="action brd-lr" onClick={() => setOpenNotiModel('EXCEL')}>
                    Excel
                    <span className="export-icon">
                        <Export />
                    </span>
                </div>
                <div className="action brd-rb" onClick={() => setOpenNotiModel('SHARE')}>
                    Share
                    <span className="share-icon">
                        <Share />
                    </span>
                </div>
            </div>
            {
                openNotiModel && (
                    <NotificationModel>
                        {notificationModelContent()}
                    </NotificationModel>
                )
            }
        </React.Fragment>
    )
}

export default ActionButtonsBlock